import { Skeleton, SkeletonText, Stack } from '@chakra-ui/react';
import { Size } from '../../../../@xmcloud/types';

export const FormFieldLoading: React.FC<{ w?: Size }> = ({ w = 'xs' }) => (
	<Stack pt="7" spacing={1}>
		<SkeletonText noOfLines={1} skeletonHeight="3" w="3xs" mb="2" />
		<Skeleton h="10" w={w} borderRadius="md" />
	</Stack>
);
